import * as Yup from 'yup';
import { PqrInitialCausality } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrInitialCausality = {
    product: '',
    motive: '',
    submotive1: '',
    submotive2: '',
    submotive3: '',
    submotive4: '',
};

export const validationSchema = (
    hasSubmotive1: boolean,
    hasSubmotive2: boolean,
    hasSubmotive3: boolean,
    hasSubmotive4: boolean
) => {
    const schema: any = {
        product: Yup.string().required('El producto es obligatorio'),
        motive: Yup.string().required('El motivo es obligatorio'),
    };

    if (hasSubmotive1)
        schema.submotive1 = Yup.string().required(
            'El submotivo 1 es obligatorio'
        );
    if (hasSubmotive1 && hasSubmotive2)
        schema.submotive2 = Yup.string().required(
            'El submotivo 2 es obligatorio'
        );
    if (hasSubmotive2 && hasSubmotive3)
        schema.submotive3 = Yup.string().required(
            'El submotivo 3 es obligatorio'
        );
    if (hasSubmotive3 && hasSubmotive4)
        schema.submotive4 = Yup.string().required(
            'El submotivo 4 es obligatorio'
        );

    return Yup.object(schema);
};
